<template>
  <div class="messagePageWrap">
    <div class="message">
      <div class="commonBg" v-if="$padFalg == 'other'"></div>
      <div class="message_top">
        <div class="uploadPage_toptitle">
          <div class="messageTop">
            <div class="messageTop_left" v-if="$store.state.loginStatus !== 0">
              <div @click="allread(0)"></div>
            </div>
            <div class="messageTop_con">消息</div>
            <van-icon
              class="messageTop_right"
              name="close"
              v-show="
                this.$store.state.system == 'android' &&
                applets != 'xcx' &&
                !$store.state.isXcx &&
                this.$store.state.isInGame
              "
              @click="closeCommunity"
            />
          </div>
        </div>
        <div class="message_con_tab" v-if="$store.state.loginStatus !== 0">
          <div
            v-for="item in tabList"
            :key="item.id"
            :class="pageId == item.id ? 'curcolor' : ''"
            @click="init(item.id)"
          >
            <div class="curcolorbox">
              {{ item.name
              }}<span v-show="item.unread != 0 && pageId != item.id">{{
                item.unread
              }}</span>
            </div>
            <p class="underline" v-show="pageId == item.id"></p>
          </div>
        </div>
      </div>

      <div class="message_con">
        <reply
          ref="reply"
          :replyList="replyList"
          :pageId="pageId"
          :nextFlag="nextFlag"
          @init="init"
          @refresh="refresh"
          @changetabList="changetabList"
          @getUnread="getUnread"
        ></reply>
      </div>
    </div>
    <sideRight ref="sideRight" v-if="$padFalg != 'other'"></sideRight>
  </div>
</template>
<script>
import reply from './page/reply.vue';
import get from '../../api/get';
import qs from 'qs';
import * as _code from '../../utils/code';
import sideRight from '@/components/sideRight';
import { Toast } from 'vant';
import getTime from '../../utils/time';
export default {
  name: 'messagePage',
  components: { reply, sideRight },
  watch: {
    '$store.state.loginStatus': function () {
      if (this.$store.state.loginStatus === 1) {
        if (this.$route.query.source == 'tab') {
          if (this.scrollTop == 0) {
            this.nextFlag = true;
            this.getUnread();
            this.replyList = [];
            this.pageNo = 1;
            this.init(this.pageId);
          }
          document.querySelector('.van-pull-refresh').scrollTop =
            document.body.scrollTop =
            document.documentElement.scrollTop =
              this.scrollTop;
        }
      }
    }
  },
  data() {
    return {
      applets: window.user.weixcode ? 'xcx' : '',
      tabList: [
        { id: 1, name: '回复', unread: 0 },
        { id: 2, name: '表态', unread: 0 },
        { id: 3, name: '关注', unread: 0 },
        { id: 4, name: '通知', unread: 0 }
      ],
      replyList: [],
      positionList: [],
      focusList: [],
      noticeList: [],
      pageId: 1,
      pageNo: 0,
      nextFlag: true,
      scrollTop: 0
    };
  },
  mounted() {
    this.getUnread();
  },
  activated() {
    if (this.$route.query.source == 'tab') {
      if (this.scrollTop == 0) {
        this.nextFlag = true;
        this.getUnread();
        this.replyList = [];
        this.pageNo = 1;
        this.init(this.pageId);
      }
      document.querySelector('.van-pull-refresh').scrollTop =
        document.body.scrollTop =
        document.documentElement.scrollTop =
          this.scrollTop;
    }
    // this.getUnread("nochange");
    // if (this.$padFalg != "other") this.$refs.sideRight.init();
    // document.body.scrollTop = document.documentElement.scrollTop = 0;
    // if (this.$store.state.messageCache) {
    //   this.refresh(() => {
    //     this.$store.commit("changeMessageCache", false);
    //   });
    // }
  },
  beforeRouteLeave(to, from, next) {
    this.scrollTop = document.querySelector('.van-pull-refresh').scrollTop;
    next();
  },
  methods: {
    init(id, num, fun) {
      console.log('8888');
      // this.nextFlag = true;
      if (!fun) {
        document.querySelector('.van-pull-refresh').scrollTop =
          document.body.scrollTop =
          document.documentElement.scrollTop =
            0;
      }
      if (num == 'next' && id == this.pageId) {
        this.pageNo++;
      }
      if (id != this.pageId) {
        if (this.pageId == 2 || this.pageId == 3) {
          this.allread(this.pageId, false);
        }
        this.replyList = [];
        this.pageNo = 1;
      }
      this.pageId = id;
      let obj = {
        type: id,
        pageNo: this.pageNo,
        pageSize: 10
      };
      get.messageList(obj).then((res) => {
        if (res === undefined) return;
        let data = res.data;
        if (data.code == 0) {
          this.tabList[id - 1].unread = data.data.unReadNum;
          if (fun) {
            fun();
          }
          getTime(data.data.list);
          if (this.pageNo == 1) {
            data.data.list.forEach((item, index) => {
              if (item.content) {
                item.content = item.content.replace(/<[^>]+>/g, '');
              }
            });
            this.replyList = data.data.list;
          } else {
            data.data.list.forEach((item, index) => {
              if (item.content) {
                item.content = item.content.replace(/<[^>]+>/g, '');
              }
              this.replyList.push(item);
            });
          }
          if (data.data.list.length <= 9) {
            this.nextFlag = false;
            this.$refs.reply.changefinished(true);
          } else {
            this.nextFlag = true;
            this.$refs.reply.changefinished(false);
            // this.$refs.reply.vueTouch(); //导致数据过多时，一直持续请求接口
          }
        }
      });
    },
    changetabList(id, num) {
      num == 0
        ? (this.tabList[id].unread = 0)
        : (this.tabList[id].unread = num);
    },
    refresh(fun) {
      this.pageNo = 1;
      // this.nextFlag = true;
      let obj = {
        type: this.pageId,
        pageNo: this.pageNo,
        pageSize: 10
      };
      get.messageList(obj).then((res) => {
        if (res === undefined) return;
        let data = res.data;
        if (data.code == 0) {
          if (fun) {
            fun();
          }
          getTime(data.data.list);
          this.replyList = data.data.list;
        }
      });
    },
    getUnread() {
      let obj = {
        type: 1,
        pageNo: 1,
        pageSize: 10
      };
      get.messageList(obj).then((res) => {
        if (res === undefined) return;
        let data = res.data;
        if (data.code == 0) {
          getTime(data.data.list);
          this.tabList[0].unread = data.data.unReadNum;
          // if (data.data.unReadNum != 0 && this.pageId != 1) {
          //   this.init(1);
          // }
          this.$store.commit('changeMessageNum', [
            data.data.unReadNumTotal,
            true
          ]);
        }
      });
      let obj1 = {
        type: 2,
        pageNo: 1,
        pageSize: 10
      };
      get.messageList(obj1).then((res) => {
        if (res === undefined) return;
        let data = res.data;
        if (data.code == 0) {
          getTime(data.data.list);
          this.tabList[1].unread = data.data.unReadNum;
          // if (
          //   this.tabList[0].unread == 0 &&
          //   data.data.unReadNum != 0 &&
          //   this.pageId != 2
          // ) {
          //   this.init(2);
          // }
        }
      });
      let obj2 = {
        type: 3,
        pageNo: 1,
        pageSize: 10
      };
      get.messageList(obj2).then((res) => {
        if (res === undefined) return;
        let data = res.data;
        if (data.code == 0) {
          getTime(data.data.list);
          this.tabList[2].unread = data.data.unReadNum;
          // if (
          //   this.tabList[0].unread == 0 &&
          //   this.tabList[1].unread == 0 &&
          //   data.data.unReadNum != 0 &&
          //   this.pageId != 3
          // ) {
          //   this.init(3);
          // }
        }
      });
      let obj3 = {
        type: 4,
        pageNo: 1,
        pageSize: 10
      };
      get.messageList(obj3).then((res) => {
        if (res === undefined) return;
        let data = res.data;
        if (data.code == 0) {
          getTime(data.data.list);
          this.tabList[3].unread = data.data.unReadNum;
          // if (
          //   this.tabList[0].unread == 0 &&
          //   this.tabList[1].unread == 0 &&
          //   this.tabList[2].unread == 0 &&
          //   data.data.unReadNum != 0 &&
          //   this.pageId != 4
          // ) {
          //   this.init(4);
          // }
        }
      });
    },
    allread(type, refresh = true) {
      let obj = {
        type: type
      };
      get.messageRead(qs.stringify(obj)).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          switch (type) {
            case 0:
              this.$store.commit('changeMessageNum', [
                this.$store.state.messageNum,
                false
              ]);
              break;
            case 2:
              this.$store.commit('changeMessageNum', [
                this.tabList[1].unread,
                false
              ]);
              this.tabList[1].unread = 0;
              break;
            case 3:
              this.$store.commit('changeMessageNum', [
                this.tabList[2].unread,
                false
              ]);
              this.tabList[2].unread = 0;
              break;
            default:
              break;
          }
          if (refresh) {
            this.getUnread();
          }
          if (type == 0) {
            //全部已读
            this.refresh();
            this.$store.commit('changeMessageNum', [0, true]);
          }
        }
      });
    },
    closeCommunity() {
      window.pd.onBBSClose();
    }
  }
};
</script>
<style scoped>
.message_con {
  height: 100vh;
  /* padding-top: 2.7rem; */
  margin-top: 2.7rem;
  padding-bottom: 1.5rem;
}
</style>